<template>
  <div>
    <a-modal
      v-model:open="visible"
      :title="title"
      width="400px"
      height="200px"
      :centered="true"
      wrapClassName="xmov-form-modal"
      :after-close="onAfterClose"
    >
      <a-form
        ref="formRef"
        :model="formState"
        hideRequiredMark
        class="mt-[20px]"
      >
        <a-form-item
          v-if="type === 'account'"
          :label="$t('zhang-hao-ming-cheng')"
          name="login_name"
          :rules="[
            {
              required: true,
              message: $t('qing-shu-ru-zhang-hao-ming-cheng'),
              trigger: 'blur',
            },
            {
              pattern: accountReg,
              message: $t('620-wei-zi-mu-huo-shu-zi-huo-zi-mu-shu-zi-hun-he'),
              trigger: ['blur'],
            },
          ]"
        >
          <a-input
            v-model:value="formState.login_name"
            allowClear
            size="large"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="type === 'nickname'"
          :label="$t('ni-cheng')"
          name="acc_name"
          :rules="[
            {
              required: true,
              message: $t('qing-shu-ru-ni-cheng'),
              trigger: 'blur',
            },
          ]"
        >
          <XInput
            v-model:value="formState.acc_name"
            allowClear
            size="large"
          ></XInput>
        </a-form-item>
        <a-form-item
          v-if="type === 'team'"
          :label="$t('tuan-dui-ming-cheng')"
          name="name"
          :rules="[
            {
              required: true,
              message: $t('qing-shu-ru-tuan-dui-ming-cheng'),
              trigger: 'blur',
            },
          ]"
        >
          <XInput
            v-model:value="formState.name"
            allowClear
            :maxlength="32"
            size="large"
          ></XInput>
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button type="primary" class="w-[200px]" @click="onFinish">
          {{ $t('que-ding') }}
        </a-button>
      </template>
    </a-modal>
    <div class="account-name" @click="openModal">
      {{ name || '-' }}
      <iconpark-icon name="edit" class="ml-[2px] icon"></iconpark-icon>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { FormInstance } from 'ant-design-vue'
import { changeAccountName, updateUserInfo, changeTeamName } from '@/api'
import { accountReg } from '@/utils/form'
const { $t } = useNuxtApp()

const visible = ref(false)

const props = withDefaults(
  defineProps<{
    name: string
    title: string
    type: 'nickname' | 'account' | 'team' // 昵称|账号名称|团队名称
    editable?: boolean
  }>(),
  {
    editable: true,
  }
)

const emits = defineEmits(['reload'])

const formRef = ref<FormInstance>()
const formState = reactive<{
  login_name: string
  acc_name: string
  name: string
}>({
  login_name: props.name,
  acc_name: props.name,
  name: props.name,
})

watch(
  () => props.name,
  (cur, bef) => {
    if (cur !== bef) {
      formState.acc_name = cur
      formState.login_name = cur
      formState.name = cur
    }
  }
)

const onFinish = async () => {
  try {
    const result: any = await formRef.value?.validateFields()

    if (props.type === 'account') {
      const res = await changeAccountName(result)

      if (!res.code) {
        message.success($t('xiu-gai-zhang-hao-ming-cheng-cheng-gong'))
        visible.value = false
        useUpdateUser()
      }
    } else if (props.type === 'nickname') {
      const res = await updateUserInfo(result)
      if (!res.code) {
        message.success($t('xiu-gai-cheng-gong'))
        visible.value = false
        useUpdateUser()
      }
    } else {
      const { code } = await changeTeamName(result)
      if (code !== 0) {
        return
      }

      message.success($t('xiu-gai-cheng-gong'))
      visible.value = false
      useUpdateUser()
    }
  } catch (err) {
    console.log('validate error:', err)
  }
}

const onAfterClose = () => {
  formRef.value?.clearValidate?.()
  formState.login_name = props.name
  formState.acc_name = props.name
  formState.name = props.name
}

const openModal = () => {
  if (!props.editable) {
    return
  }

  visible.value = !visible.value
}
</script>

<style lang="scss" scoped>
.account-name {
  @apply cursor-pointer flex-y-center text-font-80;
  .icon {
    visibility: hidden;
  }
  &:hover {
    .icon {
      visibility: visible;
    }
  }
}
</style>
